import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createAuth0 } from '@auth0/auth0-vue'
import ui from '@nuxt/ui/vue-plugin'

import App from './App.vue'

const app = createApp(App)

app.use(createPinia())
app.use(ui)

app.use(
  createAuth0(
    {
      domain: import.meta.env.VITE_AUTH_DOMAIN,
      clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
      authorizationParams: {
        audience: import.meta.env.VITE_AUTH_AUDIENCE,
        redirect_uri: window.location.origin,
      },
    },
    {
      skipRedirectCallback: true,
    },
  ),
)

app.mount('#app')
